import { action } from 'satcheljs';
import type { QuickComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

/*
 * Actions to notify listeners (ex: surface, calendar module) when forms are opening
 * and closing
 */

export const onShowFullCompose = action('onShowFullCompose', (formId: string | null) => ({
    formId,
}));
export const onCloseFullCompose = action(
    'onCloseFullCompose',
    (quickComposeEntrySource: QuickComposeEntrySourceType | null) => ({
        quickComposeEntrySource: quickComposeEntrySource,
    })
);

export const onShowQuickCompose = action('onShowQuickCompose');
export const onCloseQuickCompose = action(
    'onCloseQuickCompose',
    (quickComposeEntrySource: QuickComposeEntrySourceType | null) => ({
        quickComposeEntrySource: quickComposeEntrySource,
    })
);
